import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { functionsRegion } from '@geartrack/shared-lib/dist/firebase'
import { firebaseInstance } from './firebase'

export const functionsInstance = getFunctions(firebaseInstance, functionsRegion)

if (process.env.REACT_APP_FIREBASE_EMULATORS) {
  connectFunctionsEmulator(functionsInstance, 'localhost', 5001)
}
